import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Bitbot = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M8.75 2.04999C8.75 2.4642 8.41421 2.79999 8 2.79999C7.58579 2.79999 7.25 2.4642 7.25 2.04999C7.25 1.63577 7.58579 1.29999 8 1.29999C8.41421 1.29999 8.75 1.63577 8.75 2.04999Z"
      fill="currentColor"
    />
    <path
      d="M11.5846 8.08458C11.079 8.08458 10.6692 8.49446 10.6692 9H12.5C12.5 8.49446 12.0902 8.08458 11.5846 8.08458Z"
      fill="currentColor"
    />
    <path
      d="M4.58341 8.08693C4.07712 8.08693 3.66675 8.49588 3.66675 9.00027H5.50008C5.50008 8.49588 5.08971 8.08693 4.58341 8.08693Z"
      fill="currentColor"
    />
    <path
      d="M8 11.3336C8.73635 11.3336 9.33333 10.7366 9.33333 10.0003H6.66667C6.66667 10.7366 7.26359 11.3336 8 11.3336Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.93235 3.75502C6.4436 3.57673 9.55622 3.57673 12.0675 3.75502C13.2929 3.84202 14.2668 4.76064 14.4851 5.94078C14.8601 7.96855 15.1007 9.57074 15.199 11.2806C15.2815 12.7142 14.1895 13.9177 12.7667 14C9.97195 14.1617 6.02784 14.1617 3.23306 14C1.81029 13.9177 0.718305 12.7142 0.800766 11.2806C0.89912 9.57074 1.13968 7.96854 1.51474 5.94078C1.73302 4.76064 2.7069 3.84202 3.93235 3.75502ZM11.9612 5.25125C9.52072 5.07798 6.4791 5.07798 4.03858 5.25125C3.52291 5.28786 3.08891 5.67733 2.98972 6.21359C2.61928 8.21639 2.39139 9.74815 2.29829 11.3667C2.26401 11.9627 2.71298 12.4674 3.31971 12.5025C6.05678 12.6609 9.94302 12.6609 12.6801 12.5025C13.2868 12.4674 13.7358 11.9627 13.7015 11.3667C13.6084 9.74815 13.3805 8.21639 13.0101 6.21359C12.9109 5.67734 12.4769 5.28786 11.9612 5.25125Z"
      fill="currentColor"
    />
  </Icon>
));

export default Bitbot;
